import React from "react";
import { Box, Typography } from "@mui/material";
import { GradientButtonOutline } from "components/GradientButton";
import TableData from "components/Car/Table";
import useApi from "_api/index";
import { useCarBrands } from "contexts/CarBrandsContext";
import { getBrandName } from "utils/helpers/brandCar";

const FormDocumentList = ({
  columns = [],
  data = [],
  loading = false,
  type = "buy_car",
  car,
  setBrands,
}) => {
  // const [carBrands, setCarBrands] = React.useState([]);
  // const fetchCarBrands = async () => {
  //   try {
  //     const response = await useApi.car.getOptionCarBrands();
  //     if (response.success) {
  //       setCarBrands(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching car brands:", error);
  //   }
  // };
  // React.useEffect(() => {
  //   fetchCarBrands();
  // }, []);

  const { carBrands } = useCarBrands();

  const brandName = React.useMemo(() => {
    if (!car || !car.car_brand_id) return "ยี่ห้อรถยนต์";
    return getBrandName(car.car_brand_id, carBrands);
  }, [car, carBrands]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography sx={{ mb: 2, fontSize: "32px" }}>เลือกฟอร์มเอกสาร</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: 1,
          width: "100%",
          "& > button": {
            height: "40px",
            cursor: "default",
            pointerEvents: "none",
            background: "rgba(0, 187, 159, 0.2)",
            "&:hover": {
              background: "transparent",
            },
            boxShadow: "none",
          },
        }}
      >
        <GradientButtonOutline>
          {car ? car.car_type : "รถยนต์"}
        </GradientButtonOutline>
        <GradientButtonOutline>
          {car ? brandName : "ยี่ห้อรถยนต์"}
        </GradientButtonOutline>
        <GradientButtonOutline>
          {car ? car.license_plate + " " + car.license_province : "ทะเบียนรถ"}
        </GradientButtonOutline>
      </Box>
      <TableData loading={loading} columns={columns} data={data} />
    </Box>
  );
};

export default FormDocumentList;
